import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import useFormName from '../../../../../Hooks/useFormName';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import P1DosageIntervalType from './P1DosageIntervalType';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

interface Props {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	onChange?: (value: SelectValue) => void;
}

const P1DosageIntervalTypeField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<P1DosageIntervalType {...field} />
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default P1DosageIntervalTypeField;
